/**
 * ממשק ספק וואטסאפ — שכבת ההפשטה שמאפשרת להחליף ספק בלי לגעת בקוד העסקי.
 *
 * ⚠️ רכיב גנרי בבעלות Ariana-Prj — סעיף 13.2. ראו shared/README.md
 *
 * ⭐ למה זה קיים כבר בשלב 1, כשהמימוש היחיד הוא ידני:
 *    שלושת המסלולים (ManualProvider · MetaCloudProvider · BSP ל-Coexistence) הוכרעו
 *    ב-TASKS, אבל התזמון שלהם תלוי בטל וב-Meta. הממשק הזה הוא מה שמאפשר לשלב 2 ו-3
 *    להיות **החלפת משתנה סביבה** ולא שכתוב — `WHATSAPP_PROVIDER=manual|meta`.
 */
/**
 * בונה קישור click-to-chat.
 *
 * ⚠️ `encodeURIComponent` חובה — הטקסט בעברית ו-URL לא סובל אותו גולמי (TASKS 5.3א).
 */
export function buildClickToChatUrl(toWa, prefilledText) {
    return `https://wa.me/${toWa}?text=${encodeURIComponent(prefilledText)}`;
}
//# sourceMappingURL=WhatsAppProvider.js.map